/*
 * fn: isNonEmptyString
 *
 * Determines if an input is a string that is non-empty
 *
 */
export const isNonEmptyString = <T>(value: T): value is T & string => typeof value === 'string' && value.length > 0
